import { createQueryKeys } from '@lukemorales/query-key-factory';

import {
  fetchPublicOrganizationById,
  fetchSwitcherOrganizations,
  fetchPublicOrganizations,
  fetchOrganizationById,
  fetchOrganizations,
} from '../api';
import {
  type FetchPublicOrganizationsArgs,
  type FetchOrganizationByIdArgs,
  type FetchOrganizationsArgs,
} from '../api/types/organizations.types';

export const organizationsQueryKeys = createQueryKeys('organizations', {
  fetchInfiniteOrganizations: ({ filters }: FetchOrganizationsArgs) => ({
    queryFn: (context) =>
      fetchOrganizations({
        filters: {
          ...filters,
          offset: (context?.pageParam as string) || '1',
          orderBy: filters?.orderBy || 'name',
        },
      }),
    queryKey: [filters],
  }),
  fetchInfinitePublicOrganizations: ({
    filters,
  }: FetchPublicOrganizationsArgs) => ({
    queryFn: (context) =>
      fetchPublicOrganizations({
        filters: {
          ...filters,
          offset: (context?.pageParam as string) || '1',
          orderBy: filters?.orderBy || 'name',
        },
      }),
    queryKey: [filters],
  }),
  fetchInfiniteSwitcherOrganizations: ({
    filters,
  }: FetchOrganizationsArgs) => ({
    queryFn: (context) =>
      fetchSwitcherOrganizations({
        filters: {
          ...filters,
          limit: (context?.meta?.limit as string) || '25',
          offset: (context?.pageParam as string) || '1',
          orderBy: filters?.orderBy || 'name',
        },
      }),
    queryKey: [filters],
  }),
  fetchOrganizationById: ({ id }: FetchOrganizationByIdArgs) => ({
    queryFn: () => fetchOrganizationById({ id }),
    queryKey: [id],
  }),
  fetchOrganizations: ({ filters }: FetchOrganizationsArgs) => ({
    queryFn: () => fetchOrganizations({ filters }),
    queryKey: [filters],
  }),
  fetchPublicOrganizationById: ({ id }: FetchOrganizationByIdArgs) => ({
    queryFn: () => fetchPublicOrganizationById({ id }),
    queryKey: [id],
  }),
});
